//没有用到的页面
import React from 'react'
import {
  Select,
  Input,
  Form,
  Button,
  message,
  Anchor,
  Spin,
  DatePicker,
  Card,
  Upload,
  Modal,
  BackTop
} from 'antd'
import FormItem from 'antd/lib/form/FormItem'
import { ajaxApi, fileDownloadApiNew, getMethod } from '@/server/index'
import { getParmUrl, getCookieNew,tokenConfig } from '@/public/utils'
import moment from 'moment'
import 'moment/locale/zh-cn'
import _lodash from 'lodash'
import common from '@/public/common'
import styles from './brand-qualification-edit.module.less'
import {
  InfoCircleOutlined,
  PlusOutlined,
  UploadOutlined
} from '@ant-design/icons'
const Option = Select.Option
const { TextArea } = Input
// 接口文档地址 http://confluence.vsigo.cn/pages/viewpage.action?pageId=62753109
class BrandQualificationEdit extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      spinLoading: false,
      fileList: [],
      authorizeImgList: [],
      responsibilityImgList: [],
      authorizeFileList: [],
      responsibilityFileList: [],
      previewVisible: false,
      previewImage: '',
      Modalvisible: false,
      paramData: {
        supplier_code: '',
        brand_id: null
      },
      totalDetails: {
        'brand_id': null,
        'brand_name': '',
        'supplier_code': '',
        'data': []
      },
      // 商标
      trademarkDetails: {
        'qua_name': '',
        'qua_code': '',
        'qua_man': '',
        'qua_content': '',
        'begin_time': null,
        'end_time': null,
        'image_url': [],
        'attachment_url': [],
        'warning_day': null
      },
      // 授权书
      certificateAuthorizationDetails: {
        'qua_name': '授权书',
        'qua_content': '',
        'begin_time': null,
        'end_time': null,
        'image_url': [],
        'attachment_url': [],
        'warning_day': null
      },
      // 深拷贝授权书的值、
      cloneDeepCertificateAuthorization: null,
      // 产品责任险
      ProductLiabilityInsuranceDetails: {
        'qua_name': '产品责任险',
        'qua_content': '',
        'begin_time': null,
        'end_time': null,
        'image_url': [],
        'attachment_url': [],
        'warning_day': null
      },
      // 深拷贝产品责任险的值
      cloneDeepProductLiabilityInsurance: null,
      // 修改或者添加的参数
      addOrEditPost: {
        'brand_id': null,
        'brand_name': '',
        'supplier_code': '',
        'supplier_name': '',
        'moder': '',
        'type': '',
        'change_reason': '',
        'details': [],
        'changes': []
      },
      // 授权书修改前后的值
      editCertificateAuthorizationData: {},
      // 产品责任险修改前后的值
      editProductLiabilityInsuranceData: {},
      previewVisibleAuthorize: false, // 授权书的图片展示
      previewVisibleResponsibility: false, // 产品责任险的图片展示
      subBtn: false,
      status: 'on_check',
      testUrl: window.location.host.split('t').length - 1 === 1
    }
  }

  componentDidMount () {
    let {paramData, addOrEditPost} = this.state
    // console.log(JSON.parse(getCookieNew('adminName')))
    paramData.supplier_code = getParmUrl('supplier_code') ? getParmUrl('supplier_code') : null
    paramData.brand_id = getParmUrl('brand_id') ? getParmUrl('brand_id') : null
    addOrEditPost.moder = 10
    addOrEditPost.supplier_code = getParmUrl('supplier_code') ? getParmUrl('supplier_code') : null
    // console.log(moment('2020-10-07'))

    this.setState({
      paramData,
      addOrEditPost,
      status: getParmUrl('status') ? getParmUrl('status') : 'on_check'
    }, () => {
      this.getDetailData()
    })
  }

  // 获取详情的值
  getDetailData=async () => {
    let {paramData, addOrEditPost, testUrl, trademarkDetails, certificateAuthorizationDetails, ProductLiabilityInsuranceDetails, authorizeImgList, responsibilityImgList, authorizeFileList, responsibilityFileList, cloneDeepCertificateAuthorization, cloneDeepProductLiabilityInsurance} = this.state
    try {
      let res = await ajaxApi({
        url: common.SapUrl + 'brand-qua/query-detail',
        // url: 'http://192.168.10.220:8120/brand-qua/query-detail',
        params: paramData
      })
      // console.log(res)
      if (res.status === 200) {
        if (res.data.data && res.data.data.length !== 0) {
          addOrEditPost.brand_id = res.data.brand_id
          addOrEditPost.brand_name = res.data.brand_name
          addOrEditPost.supplier_name = getCookieNew('adminName') ? JSON.parse(getCookieNew('adminName')).AccountName : ''
          addOrEditPost.moder = getCookieNew('adminName') ? JSON.parse(getCookieNew('adminName')).RealName : ''
          if (res.data.data.length === 1) {
            addOrEditPost.type = 'add'
            trademarkDetails = res.data.data[0]
            this.setState({
              addOrEditPost,
              trademarkDetails
            })
          } else {
            addOrEditPost.type = 'edit'
            res.data.data.map((item, index) => {
              if (item.qua_name === '授权书') {
                certificateAuthorizationDetails = res.data.data[index]
                res.data.data[index].image_url.map((item, index) => {
                  authorizeImgList.push({
                    uid: index.toString(),
                    name: 'image.png',
                    response: {url: item},
                    status: 'done',
                    url: (testUrl ? 'http://static-t.njtuling.com/erp/zizhi/img/' : 'http://static.njtuling.com/erp/zizhi/img/') + item
                  })
                })

                if (res.data.data[index].attachment_url) {
                  res.data.data[index].attachment_url.map((item, index) => {
                    authorizeFileList.push({
                      uid: index.toString(),
                      name: item,
                      response: {url: item},
                      status: 'done',
                      url: (testUrl ? 'http://static-t.njtuling.com/erp/zizhi/file/' : 'http://static.njtuling.com/erp/zizhi/file/') + item
                    })
                  })
                }
                cloneDeepCertificateAuthorization = _lodash.cloneDeep(res.data.data[index])
              } else if (item.qua_name === '产品责任险') {
                ProductLiabilityInsuranceDetails = res.data.data[index]
                cloneDeepProductLiabilityInsurance = _lodash.cloneDeep(res.data.data[index])
                res.data.data[index].image_url.map((item, index) => {
                  responsibilityImgList.push({
                    uid: index.toString(),
                    name: 'image.png',
                    response: {url: item},
                    status: 'done',
                    url: (testUrl ? 'http://static-t.njtuling.com/erp/zizhi/img/' : 'http://static.njtuling.com/erp/zizhi/img/') + item
                  })
                })

                if (res.data.data[index].attachment_url) {
                  res.data.data[index].attachment_url.map((item, index) => {
                    responsibilityFileList.push({
                      uid: index.toString(),
                      name: item,
                      response: {url: item},
                      status: 'done',
                      url: (testUrl ? 'http://static-t.njtuling.com/erp/zizhi/file/' : 'http://static.njtuling.com/erp/zizhi/file/') + item
                    })
                  })
                }
              } else {
                trademarkDetails = res.data.data[index]
              }
            })
            this.setState({
              addOrEditPost,
              trademarkDetails,
              ProductLiabilityInsuranceDetails,
              certificateAuthorizationDetails,
              authorizeImgList,
              responsibilityImgList,
              authorizeFileList,
              responsibilityFileList,
              cloneDeepCertificateAuthorization,
              cloneDeepProductLiabilityInsurance
            })
          }
        }
      }
    } catch (e) {
      console.log(e)
    }
  }

  // 授权书图片预览
  handlePreviewResponsibility=(file) => {
    this.setState({
      previewImageAuthorize: file.url || file.thumbUrl,
      previewVisibleAuthorize: true
    })
  }

  // 产品责任险图片预览
  handlePrevIewAuthorize = (file) => {
    this.setState({
      previewImageResponsibility: file.url || file.thumbUrl,
      previewVisibleResponsibility: true
    })
  }

  // 取消图片预览
  handleCancel=() => {
    this.setState({
      previewVisibleAuthorize: false,
      previewVisibleResponsibility: false
    })
  }

  // 授权上传
  handleChangeAuthorize = ({ file, fileList }) => {
    let {authorizeImgList} = this.state
    if (file.status === 'done') {
      fileList = fileList.map((item, index) => {
        // 相关文件对象数据格式化处理
        return item
      })
    }
    // 避免原来的文件丢失，这样子写就可以了
    this.setState({
      authorizeImgList: fileList
    })
  }

  // 产品责任险图片上传
  handleChangeResponsibility=({ file, fileList }) => {
    let {responsibilityImgList} = this.state
    if (file.status === 'done') {
      fileList = fileList.map((item, index) => {
        // 相关文件对象数据格式化处理
        return item
      })
    }
    // 避免原来的文件丢失，这样子写就可以了
    this.setState({
      responsibilityImgList: fileList
    })
  }

  // 授权书上传文佳
  handleChangeFileAuthorize = info => {
    let {authorizeFileList, testUrl} = this.state
    let fileList = [...info.fileList]
    // 1. 限制上载的文件数
    // 只显示两个最近上传的文件，旧文件将被新文件替换
    // fileList = fileList.slice(-2)
    // 2. 从响应读取并显示文件链接
    fileList = fileList.map(file => {
      if (file.response) {
        // 组件将显示文件.url作为链接
        file.url = (testUrl ? 'http://static-t.njtuling.com/erp/zizhi/file/' : 'http://static.njtuling.com/erp/zizhi/file/') + file.response.url
      }
      return file
    })
    this.setState({
      authorizeFileList: fileList
    })
  };

  // 产品责任险上传文件
  handleChangeFileResponsibility=(info) => {
    let {responsibilityFileList, testUrl} = this.state
    let fileList = [...info.fileList]
    // 1. 限制上载的文件数
    // 只显示两个最近上传的文件，旧文件将被新文件替换
    // fileList = fileList.slice(-2)
    // 2. 从响应读取并显示文件链接
    fileList = fileList.map(file => {
      if (file.response) {
        // 组件将显示文件.url作为链接
        file.url = (testUrl ? 'http://static-t.njtuling.com/erp/zizhi/file/' : 'http://static.njtuling.com/erp/zizhi/file/') + file.response.url
      }
      return file
    })
    this.setState({
      responsibilityFileList: fileList
    })
  }

  // 获取时间的值
  handleChangeDate=(e, name, genre) => {
    let {addOrEditPost, certificateAuthorizationDetails, ProductLiabilityInsuranceDetails, cloneDeepCertificateAuthorization, cloneDeepProductLiabilityInsurance, editCertificateAuthorizationData, editProductLiabilityInsuranceData} = this.state
    if (genre === '授权书') {
      certificateAuthorizationDetails[name] = e ? moment(e).valueOf() : null
    } else {
      ProductLiabilityInsuranceDetails[name] = e ? moment(e).valueOf() : null
    }
    if (addOrEditPost.type === 'edit') {
      if (addOrEditPost.changes.length !== 0) {
        if (genre === '授权书') {
          if (name === 'begin_time') {
            if (moment(e).valueOf() !== cloneDeepCertificateAuthorization.begin_time) {
              let _index = _lodash.findIndex(addOrEditPost.changes, (e) => {
                return e.change_filed === '授权书-开始时间'
              })
              if (_index > 0 || _index === 0) {
                addOrEditPost.changes[_index].after_value = e ? moment(e).valueOf() : null
              } else {
                addOrEditPost.changes.push({
                  change_filed: '授权书-开始时间',
                  before_value: cloneDeepCertificateAuthorization ? cloneDeepCertificateAuthorization.begin_time ? cloneDeepCertificateAuthorization.begin_time : null : null,
                  after_value: e ? moment(e).valueOf() : null
                })
              }
            }
          } else {
            if (moment(e).valueOf() !== cloneDeepCertificateAuthorization.end_time) {
              let _index = _lodash.findIndex(addOrEditPost.changes, (e) => {
                return e.change_filed === '授权书-结束时间'
              })
              if (_index > 0 || _index === 0) {
                addOrEditPost.changes[_index].after_value = e ? moment(e).valueOf() : null
              } else {
                addOrEditPost.changes.push({
                  change_filed: '授权书-结束时间',
                  before_value: cloneDeepCertificateAuthorization ? cloneDeepCertificateAuthorization.end_time ? cloneDeepCertificateAuthorization.end_time : null : null,
                  after_value: e ? moment(e).valueOf() : null
                })
              }
            }
          }
        } else {
          if (name === 'begin_time') {
            if (moment(e).valueOf() !== cloneDeepCertificateAuthorization.begin_time) {
              let _index = _lodash.findIndex(addOrEditPost.changes, (e) => {
                return e.change_filed === '产品责任险-开始时间'
              })
              if (_index > 0 || _index === 0) {
                addOrEditPost.changes[_index].after_value = e ? moment(e).valueOf() : null
              } else {
                addOrEditPost.changes.push({
                  change_filed: '产品责任险-开始时间',
                  before_value: cloneDeepProductLiabilityInsurance ? cloneDeepProductLiabilityInsurance.begin_time ? cloneDeepProductLiabilityInsurance.begin_time : null : null,
                  after_value: e ? moment(e).valueOf() : null
                })
              }
            }
          } else {
            if (moment(e).valueOf() !== cloneDeepCertificateAuthorization.end_time) {
              let _index = _lodash.findIndex(addOrEditPost.changes, (e) => {
                return e.change_filed === '产品责任险-结束时间'
              })
              if (_index > 0 || _index === 0) {
                addOrEditPost.changes[_index].after_value = e ? moment(e).valueOf() : null
              } else {
                addOrEditPost.changes.push({
                  change_filed: '产品责任险-结束时间',
                  before_value: cloneDeepProductLiabilityInsurance ? cloneDeepProductLiabilityInsurance.end_time ? cloneDeepProductLiabilityInsurance.end_time : null : null,
                  after_value: e ? moment(e).valueOf() : null
                })
              }
            }
          }
        }
      } else {
        if (genre === '授权书') {
          if (name === 'begin_time') {
            addOrEditPost.changes.push({
              change_filed: '授权书-开始时间',
              before_value: cloneDeepCertificateAuthorization ? cloneDeepCertificateAuthorization.begin_time ? cloneDeepCertificateAuthorization.begin_time : null : null,
              after_value: e ? moment(e).valueOf() : null
            })
          } else {
            addOrEditPost.changes.push({
              change_filed: '授权书-结束时间',
              before_value: cloneDeepCertificateAuthorization ? cloneDeepCertificateAuthorization.end_time ? cloneDeepCertificateAuthorization.end_time : null : null,
              after_value: e ? moment(e).valueOf() : null
            })
          }
        } else {
          if (name === 'begin_time') {
            addOrEditPost.changes.push({
              change_filed: '产品责任险-开始时间',
              before_value: cloneDeepProductLiabilityInsurance ? cloneDeepProductLiabilityInsurance.begin_time ? cloneDeepProductLiabilityInsurance.begin_time : null : null,
              after_value: e ? moment(e).valueOf() : null
            })
          } else {
            addOrEditPost.changes.push({
              change_filed: '产品责任险-结束时间',
              before_value: cloneDeepProductLiabilityInsurance ? cloneDeepProductLiabilityInsurance.end_time ? cloneDeepProductLiabilityInsurance.end_time : null : null,
              after_value: e ? moment(e).valueOf() : null
            })
          }
        }
      }
    }
    this.setState({
      certificateAuthorizationDetails,
      ProductLiabilityInsuranceDetails,
      addOrEditPost
    }, () => {
      // console.log(this.state.certificateAuthorizationDetails)
      // console.log(this.state.ProductLiabilityInsuranceDetails)
      // console.log(this.state.addOrEditPost)
    })
  }

  // 获取输入框的值
  handleInput=(e, name, genre) => {
    let {addOrEditPost, certificateAuthorizationDetails, ProductLiabilityInsuranceDetails} = this.state
    if (genre === '授权书') {
      certificateAuthorizationDetails[name] = e.target.value
    } else {
      ProductLiabilityInsuranceDetails[name] = e.target.value
    }
    this.setState({
      certificateAuthorizationDetails,
      ProductLiabilityInsuranceDetails
    }, () => {
      // console.log(this.state.certificateAuthorizationDetails)
      // console.log(this.state.ProductLiabilityInsuranceDetails)
    })
  }

  // 获取变更信息的值
  handleInputChangeReson=(e, name) => {
    let {addOrEditPost} = this.state
    addOrEditPost[name] = e.target.value
    this.setState({
      addOrEditPost
    })
  }

  // 提交
  handleSubmit=async () => {
    let {addOrEditPost, certificateAuthorizationDetails, ProductLiabilityInsuranceDetails, authorizeImgList, responsibilityImgList, authorizeFileList, responsibilityFileList, editCertificateAuthorizationData, cloneDeepCertificateAuthorization, cloneDeepProductLiabilityInsurance, testUrl} = this.state
    let _imageList = []
    let _imageListNew = []
    let _fileList = []
    let _fileListNew = []
    if (authorizeImgList.length === 0 || responsibilityImgList.length === 0) {
      message.warning('请上传授权书或产品责任险的图片')
      return
    }
    if (certificateAuthorizationDetails.begin_time === null || certificateAuthorizationDetails.end_time === null) {
      message.warning('请选择授权书时间')
      return
    }
    if (certificateAuthorizationDetails.begin_time === null || certificateAuthorizationDetails.end_time === null) {
      message.warning('请选择授权书时间')
      return
    }

    // 上传图片和文件数据重构
    authorizeImgList.map((item, index) => {
      _imageList.push(item.response.url)
    })
    responsibilityImgList.map((item, index) => {
      _imageListNew.push(item.response.url)
    })
    authorizeFileList.map((item, index) => {
      _fileList.push(item.response.url)
    })
    responsibilityFileList.map((item, index) => {
      _fileListNew.push(item.response.url)
    })

    certificateAuthorizationDetails.image_url = _imageList
    ProductLiabilityInsuranceDetails.image_url = _imageListNew
    certificateAuthorizationDetails.attachment_url = _fileList
    ProductLiabilityInsuranceDetails.attachment_url = _fileListNew

    addOrEditPost.details.push(certificateAuthorizationDetails, ProductLiabilityInsuranceDetails)
    // console.log(_imageList)
    if (addOrEditPost.type === 'edit') {
      if (addOrEditPost.changes.length !== 0) {
        // 授权书的图片
        if (cloneDeepCertificateAuthorization) {
          if (!(_lodash.isEqual(_imageList, cloneDeepCertificateAuthorization.image_url))) {
            let _index = _lodash.findIndex(addOrEditPost.changes, (e) => {
              return e.change_filed === '授权书-资质图片'
            })

            if (_index > 0 || _index === 0) {
              addOrEditPost.changes[_index].after_value = _imageList
            } else {
              addOrEditPost.changes.push({
                change_filed: '授权书-资质图片',
                before_value: cloneDeepCertificateAuthorization ? cloneDeepCertificateAuthorization.image_url ? cloneDeepCertificateAuthorization.image_url : [] : [],
                after_value: _imageList
              })
            }
          }
        }

        // 授权书的文件
        if (cloneDeepCertificateAuthorization) {
          if (!(_lodash.isEqual(_fileList, cloneDeepCertificateAuthorization.attachment_url))) {
            let _index = _lodash.findIndex(addOrEditPost.changes, (e) => {
              return e.change_filed === '授权书-附件'
            })

            if (_index > 0 || _index === 0) {
              addOrEditPost.changes[_index].after_value = _fileList
            } else {
              addOrEditPost.changes.push({
                change_filed: '授权书-附件',
                before_value: cloneDeepCertificateAuthorization ? cloneDeepCertificateAuthorization.attachment_url ? cloneDeepCertificateAuthorization.attachment_url : [] : [],
                after_value: _fileList
              })
            }
          }
        }

        // 授权书的资质内容
        if (cloneDeepCertificateAuthorization) {
          if (certificateAuthorizationDetails.qua_content !== cloneDeepCertificateAuthorization.qua_content) {
            let _indexText = _lodash.findIndex(addOrEditPost.changes, (e) => {
              return e.change_filed === '授权书-资质内容'
            })
            if (_indexText > 0 || _indexText === 0) {
              addOrEditPost.changes[_indexText].after_value = certificateAuthorizationDetails.qua_content
            } else {
              addOrEditPost.changes.push({
                change_filed: '授权书-资质内容',
                before_value: cloneDeepCertificateAuthorization ? cloneDeepCertificateAuthorization.qua_content ? cloneDeepCertificateAuthorization.qua_content : '' : '',
                after_value: certificateAuthorizationDetails.qua_content
              })
            }
          }
        }

        // 产品责任险的图片
        if (cloneDeepProductLiabilityInsurance) {
          if (!(_lodash.isEqual(_imageListNew, cloneDeepProductLiabilityInsurance.image_url))) {
            let _indexNew = _lodash.findIndex(addOrEditPost.changes, (e) => {
              return e.change_filed === '产品责任险-资质图片'
            })
            if (_indexNew > 0 || _indexNew === 0) {
              addOrEditPost.changes[_indexNew].after_value = _imageListNew
            } else {
              addOrEditPost.changes.push({
                change_filed: '产品责任险-资质图片',
                before_value: cloneDeepProductLiabilityInsurance ? cloneDeepProductLiabilityInsurance.image_url ? cloneDeepProductLiabilityInsurance.image_url : [] : [],
                after_value: _imageListNew
              })
            }
          }
        }

        // 产品责任险的文件
        if (cloneDeepProductLiabilityInsurance) {
          if (!(_lodash.isEqual(_fileListNew, cloneDeepProductLiabilityInsurance.attachment_url))) {
            let _indexNew = _lodash.findIndex(addOrEditPost.changes, (e) => {
              return e.change_filed === '产品责任险-附件'
            })
            if (_indexNew > 0 || _indexNew === 0) {
              addOrEditPost.changes[_indexNew].after_value = _fileListNew
            } else {
              addOrEditPost.changes.push({
                change_filed: '产品责任险-附件',
                before_value: cloneDeepProductLiabilityInsurance ? cloneDeepProductLiabilityInsurance.attachment_url ? cloneDeepProductLiabilityInsurance.attachment_url : [] : [],
                after_value: _fileListNew
              })
            }
          }
        }

        // 产品责任险的资质内容
        if (cloneDeepProductLiabilityInsurance) {
          if (ProductLiabilityInsuranceDetails.qua_content !== cloneDeepProductLiabilityInsurance.qua_content) {
            let _indexTextNew = _lodash.findIndex(addOrEditPost.changes, (e) => {
              return e.change_filed === '产品责任险-资质内容'
            })
            if (_indexTextNew > 0 || _indexTextNew === 0) {
              addOrEditPost.changes[_indexTextNew].after_value = ProductLiabilityInsuranceDetails.qua_content
            } else {
              addOrEditPost.changes.push({
                change_filed: '产品责任险-资质内容',
                before_value: cloneDeepCertificateAuthorization ? cloneDeepCertificateAuthorization.qua_content ? cloneDeepCertificateAuthorization.qua_content : '' : '',
                after_value: ProductLiabilityInsuranceDetails.qua_content
              })
            }
          }
        }
      } else {
        if (!(_lodash.isEqual(_imageList, cloneDeepCertificateAuthorization.image_url))) {
          addOrEditPost.changes.push({
            change_filed: '授权书-资质图片',
            before_value: cloneDeepCertificateAuthorization ? cloneDeepCertificateAuthorization.image_url ? cloneDeepCertificateAuthorization.image_url : [] : [],
            after_value: _imageList
          })
        }

        if (!(_lodash.isEqual(_fileList, cloneDeepCertificateAuthorization.attachment_url))) {
          addOrEditPost.changes.push({
            change_filed: '授权书-附件',
            before_value: cloneDeepCertificateAuthorization ? cloneDeepCertificateAuthorization.attachment_url ? cloneDeepCertificateAuthorization.attachment_url : [] : [],
            after_value: _fileList
          })
        }

        if (!(_lodash.isEqual(_imageListNew, cloneDeepProductLiabilityInsurance.image_url))) {
          addOrEditPost.changes.push(
            {
              change_filed: '产品责任险-资质图片',
              before_value: cloneDeepProductLiabilityInsurance ? cloneDeepProductLiabilityInsurance.image_url ? cloneDeepProductLiabilityInsurance.image_url : [] : [],
              after_value: _imageListNew
            }
          )
        }

        if (!(_lodash.isEqual(_fileListNew, cloneDeepProductLiabilityInsurance.image_url))) {
          addOrEditPost.changes.push(
            {
              change_filed: '产品责任险-附件',
              before_value: cloneDeepProductLiabilityInsurance ? cloneDeepProductLiabilityInsurance.attachment_url ? cloneDeepProductLiabilityInsurance.attachment_url : [] : [],
              after_value: _fileListNew
            }
          )
        }

        if (cloneDeepCertificateAuthorization) {
          if (certificateAuthorizationDetails.qua_content !== cloneDeepCertificateAuthorization.qua_content) {
            addOrEditPost.changes.push({
              change_filed: '授权书-资质内容',
              before_value: cloneDeepCertificateAuthorization ? cloneDeepCertificateAuthorization.qua_content ? cloneDeepCertificateAuthorization.qua_content : '' : '',
              after_value: certificateAuthorizationDetails.qua_content
            })
          }
        }

        if (cloneDeepProductLiabilityInsurance) {
          if (ProductLiabilityInsuranceDetails.qua_content !== cloneDeepProductLiabilityInsurance.qua_content) {
            addOrEditPost.changes.push({
              change_filed: '产品责任险-资质内容',
              before_value: cloneDeepProductLiabilityInsurance ? cloneDeepProductLiabilityInsurance.qua_content ? cloneDeepProductLiabilityInsurance.qua_content : '' : '',
              after_value: ProductLiabilityInsuranceDetails.qua_content
            })
          }
        }
      }
      this.setState({
        Modalvisible: true
      })
    } else {
      this.setState({
        subBtn: true
      }, () => {
        this.publicSub(true)
      })
    }

    this.setState({
      addOrEditPost
    }, () => {
      // console.log(addOrEditPost)
    })
  }

  publicSub=async (type) => {
    let {addOrEditPost} = this.state
    try {
      let res = await ajaxApi({
        url: common.SapUrl + 'brand-qua/add',
        // url: 'http://192.168.10.220:8120/brand-qua/add',
        params: addOrEditPost
      })
      this.setState({
        subBtn: false
      })
      // console.log(res)
      if (res.status === 200) {
        if (type) {
          window.location.reload()
        } else {
          this.props.history.push({pathname: '/main/brandqualification/brand-qualification-list'})
        }
      } else {

      }
    } catch (err) {
      console.log(err)
    }
  }

  // 继续提交
  handleGoOnSubmii=() => {
    let {addOrEditPost} = this.state
    if (addOrEditPost.change_reason === '') {
      message.warning('请填写变更原因')
      return
    }
    this.setState({
      addOrEditPost,
      Modalvisible: false
    }, () => {
      this.publicSub()
    })
  }

  // 返回修改
  handleBlackEdit=() => {
    this.setState({
      Modalvisible: false
    })
  }

  // 取消
  handleCancle=() => {
    this.props.history.push({pathname: '/main/brandqualification/brand-qualification-list'})
  }

  // 禁止
  disabledStartDate=(startValue, type) => {
    let {certificateAuthorizationDetails, ProductLiabilityInsuranceDetails} = this.state
    let endValue
    if (type === 'shouquan') {
      endValue = certificateAuthorizationDetails.end_time
    } else {
      endValue = ProductLiabilityInsuranceDetails.end_time
    }

    if (!startValue || !endValue) {
      return false
    }
    return startValue.valueOf() > endValue
  }

  disabledEndDate=(endValue, type) => {
    let {certificateAuthorizationDetails, ProductLiabilityInsuranceDetails} = this.state
    let startValue
    if (type === 'shouquan') {
      startValue = certificateAuthorizationDetails.begin_time
    } else {
      startValue = ProductLiabilityInsuranceDetails.begin_time
    }

    if (!endValue || !startValue) {
      return false
    }
    return endValue.valueOf() < startValue
  }

  render () {
    const { previewVisible, testUrl, previewImageAuthorize, previewImageResponsibility, previewVisibleAuthorize, previewVisibleResponsibility, authorizeImgList, responsibilityImgList, authorizeFileList, responsibilityFileList, trademarkDetails, certificateAuthorizationDetails, ProductLiabilityInsuranceDetails } = this.state

    const uploadButton = (
      <div>
        <PlusOutlined />
        <div className="ant-upload-text">上传</div>
      </div>
    )

    const propsAuthorize = {
      action: common.SapUrl + 'brand-qua/upload-file',
      accept: '.xlsx,.pdf,.xls',
      onChange: this.handleChangeFileAuthorize,
      beforeUpload: this.beforeUploadFileAuthorize,
      multiple: true,
      headers:{...tokenConfig}
    }

    const propsResponsibility = {
      action: common.SapUrl + 'brand-qua/upload-file',
      accept: '.xlsx,.pdf,.xls',
      onChange: this.handleChangeFileResponsibility,
      beforeUpload: this.beforeUploadFResponsibility,
      multiple: true,
      headers:{...tokenConfig}
    }

    return (
      <div>
        <Spin spinning={this.state.spinLoading}>
          <FormItem style={{ marginBottom: '0px', fontSize: '18px' }}>
            <div>品牌资质</div>
          </FormItem>
          <div>
            <Card style={{ width: '100%' }}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'start',
                  flexWrap: 'wrap'
                }}
              >
                <div className={styles.trademark_div}>
                  <span>资质名称</span>
                  <div
                    className={styles.trademark_div_bottom}
                    style={{
                      fontSize: '20px',
                      fontWeight: '600',
                      color: 'red'
                    }}
                  >
                    <span style={{ color: 'black', marginRight: '72px' }}>
                      <span>{trademarkDetails.qua_name ? trademarkDetails.qua_name : '-'}</span>
                    </span>
                    {trademarkDetails.warning_day ? (
                      trademarkDetails.warning_day < 61 ? trademarkDetails.warning_day > 0 ? (
                        <span style={{fontSize: '18px'}}>
                          <span>过期预警</span><span>（剩余{trademarkDetails.warning_day}天）</span>
                        </span>
                      ) : <span style={{fontSize: '18px'}}>已过期</span> : null
                    )
                      : (<span style={{fontSize: '18px'}}><span>过期预警</span><span>（剩余0天）</span></span>)
                    }

                  </div>
                </div>

                <div className={styles.trademark_div}>
                  <span>资质证号</span>
                  <div className={styles.trademark_div_bottom}>
                    <Input
                      onKeyDown={this.onKeyup}
                      placeholder="请输入"
                      name="name"
                      //   value={this.state.paramData.name}
                      onChange={(e) => this.handleChangeInput(e, 'name')}
                      style={{ width: 272, marginRight: '0px', display: 'none' }}
                    />
                    <span>{trademarkDetails.qua_code ? trademarkDetails.qua_code : '-'}</span>
                  </div>
                </div>

                <div className={styles.trademark_div}>
                  <span>商品注册人</span>
                  <div className={styles.trademark_div_bottom}>
                    <span>{trademarkDetails.qua_man ? trademarkDetails.qua_man : '-'}</span>
                  </div>
                </div>

                <div className={styles.trademark_div}>
                  <span>开始时间</span>
                  <div className={styles.trademark_div_bottom}>
                  </div>
                  <span>{trademarkDetails.begin_time ? moment(trademarkDetails.begin_time).format('YYYY-MM-DD') : '-'}</span>
                </div>

                <div className={styles.trademark_div}>
                  <span>结束时间</span>
                  <div className={styles.trademark_div_bottom}>
                    <span>{trademarkDetails.end_time ? moment(trademarkDetails.end_time).format('YYYY-MM-DD') : '-'}</span>
                  </div>
                </div>
              </div>

              <div>
                <span className={styles.publi_span} style={{ float: 'left' }}>上传资质图片：</span>
                <span style={{ display: 'none', width: '93%' }}>
                </span>
                {trademarkDetails.image_url ? (
                  trademarkDetails.image_url.map((item, index) => {
                    return (
                      <a target="_blank" href={common.imageUrl+'po/qua/image/' + item}><img key={index} style={{ width: '90px', cursor: 'pointer', marginLeft: index === 0 ? '' : '8px' }} src={common.imageUrl+'po/qua/image/'+ item}></img></a>
                    )
                  })
                ) : '-'}
              </div>

              <div>
                <span className={styles.publi_span} style={{ float: 'left' }}>上传附件：</span>
                <span style={{ display: 'none', width: '93%' }}>
                  <Upload {...propsAuthorize}>
                    <Button>
                      <UploadOutlined /> 上传文件
                    </Button>
                    <span style={{display: 'inline-block', marginLeft: '8px', color: '#cccccc'}}>支持扩展名：.rar .zip .doc .docx .pdf .jpg...</span>
                  </Upload>
                </span>
                {trademarkDetails.attachment_url ? (
                  trademarkDetails.attachment_url.map((item, index) => {
                    return (
                      <a target="_blank" href={common.imageUrl+'po/qua/file/' + item} key = {index}>{item}</a>
                    )
                  })
                ) : '-'}
              </div>

              <div style={{ marginTop: '16px' }}>
                <span style={{ float: 'left' }}>资质内容：</span>
                <TextArea rows={4} style={{ width: '50%', display: 'none' }} />
                <span>{trademarkDetails.qua_content ? trademarkDetails.qua_content : '-'}</span>
              </div>
            </Card>

            <Card style={{ width: '100%', marginTop: '24px' }}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'start',
                  flexWrap: 'wrap'
                }}
              >
                <div className={styles.trademark_div}>
                  <span>资质名称</span>
                  <div
                    className={styles.trademark_div_bottom}
                    style={{
                      fontSize: '20px',
                      fontWeight: '600',
                      color: 'red'
                    }}
                  >
                    <span style={{ color: 'black', marginRight: '72px' }}>
                      <span>{certificateAuthorizationDetails.qua_name ? certificateAuthorizationDetails.qua_name : '-'}</span>
                    </span>
                    {certificateAuthorizationDetails.warning_day ? (
                      certificateAuthorizationDetails.warning_day < 61 ? certificateAuthorizationDetails.warning_day > 0 ? (
                        <span style={{fontSize: '18px'}}>
                          <span>过期预警</span><span>（剩余{certificateAuthorizationDetails.warning_day}天）</span>
                        </span>
                      ) : <span style={{fontSize: '18px'}}>已过期</span> : null
                    )
                      : (<span style={{fontSize: '18px'}}><span>过期预警</span><span>（剩余0天）</span></span>)
                    }
                  </div>
                </div>

                <div className={styles.trademark_div}>
                  <span>开始时间</span>
                  <div className={styles.trademark_div_bottom}>
                    <DatePicker
                      onOpenChange={this.handleOpenChange}
                      disabledDate={(e) => this.disabledStartDate(e, 'shouquan')}
                      format="YYYY-MM-DD"
                      style={{ width: '272px' }}
                      onChange={(e) => this.handleChangeDate(e, 'begin_time', '授权书')}
                      value ={certificateAuthorizationDetails.begin_time ? moment(certificateAuthorizationDetails.begin_time) : null}
                    />
                  </div>
                </div>

                <div className={styles.trademark_div}>
                  <span>结束时间</span>
                  <div className={styles.trademark_div_bottom}>
                    <DatePicker
                      onOpenChange={this.handleOpenChange}
                      disabledDate={(e) => this.disabledEndDate(e, 'shouquan')}
                      format="YYYY-MM-DD"
                      style={{ width: '272px' }}
                      onPanelChange={this.handlePanelChange}
                      onChange={(e) => this.handleChangeDate(e, 'end_time', '授权书')}
                      value ={certificateAuthorizationDetails.end_time ? moment(certificateAuthorizationDetails.end_time) : null}
                    />
                  </div>
                </div>
              </div>

              <div>
                <span className={styles.publi_span} style={{ float: 'left' }}>上传资质图片：</span>
                <span style={{ display: 'inline-block', width: '93%' }}>
                  <Upload
                    action = {common.SapUrl + 'brand-qua/upload-file'}
                    headers={{...tokenConfig}}
                    listType="picture-card"
                    accept='image/jpeg,image/jpg,image/png'
                    fileList={authorizeImgList}
                    beforeUpload={this.handleBeforeUploadAuthorize}
                    onPreview={this.handlePrevIewAuthorize}
                    onChange={this.handleChangeAuthorize}
                  >
                    {authorizeImgList.length >= 8 ? null : uploadButton}
                  </Upload>
                  <Modal
                    visible={previewVisibleAuthorize}
                    footer={null}
                    width={800}
                    onCancel={this.handleCancel}
                  >
                    <img
                      alt="example"
                      style={{ width: '100%' }}
                      src={previewImageAuthorize}
                    />
                  </Modal>
                </span>
              </div>

              <div>
                <span className={styles.publi_span} style={{ float: 'left' }}>上传附件：</span>
                <span style={{ display: 'inline-block', width: '93%' }}>
                  <Upload {...propsAuthorize} fileList={this.state.authorizeFileList}>
                    <Button>
                      <UploadOutlined /> 上传文件
                    </Button>
                    <span style={{display: 'inline-block', marginLeft: '8px', color: '#cccccc'}}>支持扩展名：.pdf</span>
                  </Upload>
                </span>
              </div>

              <div style={{ marginTop: '16px' }}>
                <span style={{ float: 'left' }}>资质内容：</span>
                <TextArea value={certificateAuthorizationDetails.qua_content ? certificateAuthorizationDetails.qua_content : ''} rows={4} style={{ width: '50%' }} onChange={(e) => this.handleInput(e, 'qua_content', '授权书')}/>
              </div>
            </Card>

            <Card style={{ width: '100%', marginTop: '24px' }}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'start',
                  flexWrap: 'wrap'
                }}
              >
                <div className={styles.trademark_div}>
                  <span>资质名称</span>
                  <div
                    className={styles.trademark_div_bottom}
                    style={{
                      fontSize: '20px',
                      fontWeight: '600',
                      color: 'red'
                    }}
                  >
                    <span style={{ color: 'black', marginRight: '72px' }}>
                      {ProductLiabilityInsuranceDetails.qua_name ? ProductLiabilityInsuranceDetails.qua_name : null}
                    </span>
                    {ProductLiabilityInsuranceDetails.warning_day ? (
                      ProductLiabilityInsuranceDetails.warning_day < 61 ? ProductLiabilityInsuranceDetails.warning_day > 0 ? (
                        <span style={{fontSize: '18px'}}>
                          <span>过期预警</span><span>（剩余{ProductLiabilityInsuranceDetails.warning_day}天）</span>
                        </span>
                      ) : <span style={{fontSize: '18px'}}>已过期</span> : null
                    )
                      : (<span style={{fontSize: '18px'}}><span>过期预警</span><span>（剩余0天）</span></span>)
                    }
                  </div>
                </div>

                <div className={styles.trademark_div}>
                  <span>开始时间</span>
                  <div className={styles.trademark_div_bottom}>
                    <DatePicker
                      onOpenChange={this.handleOpenChange}
                      disabledDate={(e) => this.disabledStartDate(e, 'zeren')}
                      format="YYYY-MM-DD"
                      style={{ width: '272px' }}
                      onPanelChange={this.handlePanelChange}
                      onChange={(e) => this.handleChangeDate(e, 'begin_time', '责任')}
                      value ={ProductLiabilityInsuranceDetails.begin_time ? moment(ProductLiabilityInsuranceDetails.begin_time) : null}
                    />
                  </div>
                </div>

                <div className={styles.trademark_div}>
                  <span>结束时间</span>
                  <div className={styles.trademark_div_bottom}>
                    <DatePicker
                      onOpenChange={this.handleOpenChange}
                      disabledDate={(e) => this.disabledEndDate(e, 'zeren')}
                      format="YYYY-MM-DD"
                      style={{ width: '272px' }}
                      onPanelChange={this.handlePanelChange}
                      onChange={(e) => this.handleChangeDate(e, 'end_time', '责任')}
                      value ={ProductLiabilityInsuranceDetails.end_time ? moment(ProductLiabilityInsuranceDetails.end_time) : null}
                    />
                  </div>
                </div>
              </div>

              <div>
                <span className={styles.publi_span} style={{ float: 'left' }}>上传资质图片：</span>
                <span style={{ display: 'inline-block', width: '93%' }}>
                  <Upload
                    action = {common.SapUrl + 'brand-qua/upload-file'}
                    headers={{...tokenConfig}}
                    listType="picture-card"
                    accept='image/jpeg,image/jpg,image/png'
                    fileList={responsibilityImgList}
                    beforeUpload={this.handleBeforeUploadResponsibility}
                    onPreview={this.handlePreviewResponsibility}
                    onChange={this.handleChangeResponsibility}
                  >
                    {responsibilityImgList.length >= 8 ? null : uploadButton}
                  </Upload>
                  <Modal
                    visible={previewVisibleResponsibility}
                    footer={null}
                    onCancel={this.handleCancel}
                  >
                    <img
                      alt='example'
                      style={{ width: '100%' }}
                      src={previewImageResponsibility}
                    />
                  </Modal>
                </span>
              </div>

              <div>
                <span className={styles.publi_span} style={{ float: 'left' }}>上传附件：</span>
                <span style={{ display: 'inline-block', width: '93%' }}>
                  <Upload {...propsResponsibility} fileList = {responsibilityFileList}>
                    <Button>
                      <UploadOutlined /> 上传文件
                    </Button>
                    <span style={{display: 'inline-block', marginLeft: '8px', color: '#cccccc'}}>支持扩展名： .pdf</span>
                  </Upload>
                </span>
              </div>

              <div style={{ marginTop: '16px' }}>
                <span style={{ float: 'left' }}>资质内容：</span>
                <TextArea value={ProductLiabilityInsuranceDetails.qua_content ? ProductLiabilityInsuranceDetails.qua_content : ''} rows={4} style={{ width: '50%' }} onChange={(e) => this.handleInput(e, 'qua_content', '责任')} />
              </div>
            </Card>

            <div style={{textAlign: 'center', margin: '24px 0px'}}>
              <Button type='primary' style={{marginLeft: '28px', display: this.state.status === 'on_check' ? 'none' : 'inline-block'}} loading={this.state.subBtn} onKeyDown={this.onKeyup} onClick={this.handleSubmit}>提交</Button>
              <Button type='primary' style={{margin: '0px 8px'}} onClick={this.handleCancle}>取消</Button>
            </div>
          </div>
        </Spin>

        <div>

          <Modal
            width={500}
            title=""
            visible={this.state.Modalvisible}
            onOk={this.handleOk}
            onCancel={this.handleBlackEdit}
            footer={false}
          >
            <div>
              <InfoCircleOutlined style={{fontSize: '20px', color: '#F4A460', float: 'left'}}/>
              <span style={{fontSize: '16px', marginLeft: '8px'}}>请填写信息变更的原因！</span>
            </div>
            <div style={{marginTop: '16px', marginLeft: '30px'}}>
              <TextArea style={{width: '70%'}} rows={4} onChange={(e) => this.handleInputChangeReson(e, 'change_reason')}></TextArea>
            </div>
            <div style={{marginLeft: '30px', marginTop: '8px'}}>
              <a onClick={this.handleBlackEdit}>返回修改</a>|<a onClick={this.handleGoOnSubmii}>继续提交</a>
            </div>
          </Modal>
          <BackTop visibilityHeight={40}/>

        </div>
      </div>
    )
  }
}
export default BrandQualificationEdit



// WEBPACK FOOTER //
// ./src/pages/brandqualification/brand-qualification-edit.js